import React, {useEffect, useState} from 'react';
import Cookies from "js-cookie";
import './styleWeek.css';

import axios from "axios";
import {DOMEN_BASE} from "../../assets/config/constants";
import GridWeek from "./gridWeek/gridWeek";
import BookingPreview from "../../components/BookingPreview";

function Week(props) {

    const addNull = (v) => v > 9 ? v : '0' + v;

    const make___Date = (dat) => {
        return dat.getFullYear() + "-"
            + addNull((dat.getMonth() + 1)) + "-"
            + addNull(dat.getDate());
    };


    const [mDateN, setDateN] = useState((Cookies.get('date_n')) ? Cookies.get('date_n') : make___Date(new Date()));
    const [isLoading, setIsLoading] = useState(true);
    const [dataWeek, setDataWeek] = useState(0);
    const [selectedBooking, setSelectedBooking] = useState(null);

    const WEEK = 7;

    useEffect(() => {
            setIsLoading(true);
        },
        [mDateN]);

    useEffect(() => {
        let startTouchX_W = 0;
        let endTouchX_W = 0;
        let rasst_W = 0;

        const handleTouchStart = (e) => {
            startTouchX_W = e.changedTouches[0].pageX;
            // console.log('начало : ', startTouchX_W);
        };

        const handleTouchEnd = (e) => {
            endTouchX_W = e.changedTouches[0].pageX;
            // console.log('конец : ', endTouchX_W);
            rasst_W = Math.abs(startTouchX_W - endTouchX_W);
            if (rasst_W > 100)
                changeDate((startTouchX_W < endTouchX_W) ? true : false);
        };
        window.addEventListener('touchstart', handleTouchStart);
        window.addEventListener('touchend', handleTouchEnd);


        return () => {
            window.removeEventListener('touchstart', handleTouchStart);
            window.removeEventListener('touchend', handleTouchEnd);
        };


    });

    const changeDate = flag => {
        makeDate((flag) ? -1 : 1);
    };

    const makeDate = (k) => {
        let date = new Date(mDateN);
        date.setDate(date.getDate() + (WEEK * k));
        setDateN(make___Date(date));
    };


    const getData = async (date) => {
        // console.log('path : ', DOMEN + '/ui/getWeek.php');
        return await axios.get(DOMEN_BASE + '/ui/getWeek.php', {
            params: {
                date_n: date,
            }
        })
            .then(({data}) => {
                // console.log(data.records);
                return data.records;
            })
            .catch(err => {
                alert(err.message);
                // return false;
            })
            .finally(() => setIsLoading(false));
    };

    useEffect(() => {
        if (isLoading)
            getData(mDateN).then(t => setDataWeek(t));
    });

    const getClientData = async (id) => {
        await axios.get(DOMEN_BASE + '/ui/getClientData.php', {
            params: {
                id: id,
            }
        })
            .then(({data}) => {
                setSelectedBooking((data) ? data.records : null);
                // return data;
            })
            .catch(err => {
                alert(err.message);
                // return false;
            });
    };


    return (
        <>
            <div>
                <div className="week_panel">
                    <div className="date_week">
                        <label htmlFor="date_n">Дата : </label>
                        <input type="date" name="date_n" id="date_n" value={mDateN}
                               onChange={e => {
                                   setDateN(e.target.value);
                                   Cookies.set('date_n', e.target.value);
                                   setIsLoading(true);
                               }}/>
                    </div>
                </div>
                <GridWeek _data={dataWeek} _clk={getClientData}/>
            </div>
            <BookingPreview
                booking={selectedBooking}
                onClose={() => setSelectedBooking(null)}
            />
        </>
    );
}

export default Week;
